// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3ilhQ","header":"Messages_header__1LFtF"};